import { atomWithStorage } from 'jotai/utils';

import { CountryCode } from '../api-types/common';

let countryCodes;

export const COUNTRY_CODES_LOCAL_STORAGE_KEY = 'selectedCountryCodes';

export function invalidateCachedCountryCodes() {
  // set empty array instead of removing item to make sure atom works correctly
  localStorage.setItem(COUNTRY_CODES_LOCAL_STORAGE_KEY, JSON.stringify([]));
}

try {
  const codes = localStorage.getItem(COUNTRY_CODES_LOCAL_STORAGE_KEY);
  countryCodes = codes ? JSON.parse(codes) : [];
} catch {
  countryCodes = [];
}

export const selectedCountryCodesAtom = atomWithStorage<CountryCode[]>(
  COUNTRY_CODES_LOCAL_STORAGE_KEY,
  countryCodes,
);
